import { Toggle, Translation } from '@ps/web-shared-components';
import React, { type FunctionComponent, useEffect } from 'react';
import { useForm, useFormState } from 'react-final-form';

import type { FormValues } from '../ESGamingLimitForm';

import {
  TXTWCL_A_selection_is_requiredX,
  TXTWCL_Restrict_future_play_when_one__ELL
} from './FuturePlayRestrictionSection.messages.json';
import styles from './FuturePlayRestrictionSection.scss';
import FuturePlayRestrictionTimeSelect from './FuturePlayRestrictionTimeSelect/FuturePlayRestrictionTimeSelect';

const FuturePlayRestrictionSection: FunctionComponent = () => {
  const {
    values: { enableBlockAmount },
    errors
  } = useFormState<FormValues>();
  const { change } = useForm<FormValues>();

  useEffect(() => {
    if (!enableBlockAmount) change('blockAmount', null);
  }, [enableBlockAmount, change]);

  const isError = errors?.blockAmount;

  return (
    <div>
      <Toggle
        className={styles.toggleLabel}
        label={<Translation {...TXTWCL_Restrict_future_play_when_one__ELL} />}
        id="enableBlockAmount"
        type="checkbox"
      />
      {enableBlockAmount && <FuturePlayRestrictionTimeSelect />}
      {isError && (
        <p className={styles.error}>
          <Translation {...TXTWCL_A_selection_is_requiredX} />
        </p>
      )}
    </div>
  );
};

export default FuturePlayRestrictionSection;
